"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _DeleteButton = _interopRequireDefault(require("../../components/crud/DeleteButton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var PushNotifications2 = /*#__PURE__*/function (_React$Component) {
  _inherits(PushNotifications2, _React$Component);

  function PushNotifications2() {
    _classCallCheck(this, PushNotifications2);

    return _possibleConstructorReturn(this, _getPrototypeOf(PushNotifications2).apply(this, arguments));
  }

  _createClass(PushNotifications2, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "credit-card-management"
      }, _react["default"].createElement("div", {
        className: "activated-cards"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "box-header"
      }, _react["default"].createElement("h2", null, _react["default"].createElement("i", {
        className: "fa fa-bell"
      }), " System Notifications", ' ')), _react["default"].createElement("form", {
        style: {
          paddingLeft: '15px',
          paddingRight: '15px',
          position: 'relative',
          marginBottom: '15px',
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, _react["default"].createElement("div", {
        style: {
          width: '100%'
        }
      }, _react["default"].createElement("input", {
        type: "search",
        style: {
          maxWidth: '25%',
          marginRight: '20px'
        },
        placeholder: "Search"
      }), _react["default"].createElement("button", {
        type: "submit",
        className: "button-round width-180"
      }, "Apply")), _react["default"].createElement(_reactRouterDom.Link, {
        to: "/push-notifications/add-new"
      }, _react["default"].createElement("button", {
        type: "button",
        className: "button-round width-180"
      }, "Add New"))), _react["default"].createElement("div", {
        className: "box-body"
      }, _react["default"].createElement("table", {
        className: "table"
      }, _react["default"].createElement("tbody", null, _react["default"].createElement("tr", {
        className: "tr-dark-bg"
      }, _react["default"].createElement("td", {
        style: {
          width: '10%'
        }
      }, "Id"), _react["default"].createElement("td", null, "Title"), _react["default"].createElement("td", null, "User Group"), _react["default"].createElement("td", null, "No. of Messages"), _react["default"].createElement("td", null, "Date"), _react["default"].createElement("td", {
        align: "center",
        style: {
          width: '20%'
        }
      }, "Actions")), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "1"), _react["default"].createElement("td", null, "Message 1"), _react["default"].createElement("td", null, "10"), _react["default"].createElement("td", null, "25000"), _react["default"].createElement("td", null, "02/8/20107"), _react["default"].createElement("td", {
        align: "center"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/push-notifications/push-details",
        className: "button-info"
      }, "Details"))), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "2"), _react["default"].createElement("td", null, "Message 2"), _react["default"].createElement("td", null, "2"), _react["default"].createElement("td", null, "100"), _react["default"].createElement("td", null, "18/7/20107"), _react["default"].createElement("td", {
        align: "center"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/push-notifications/push-details",
        className: "button-info"
      }, "Details"))), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "3"), _react["default"].createElement("td", null, "Message 3"), _react["default"].createElement("td", null, "40"), _react["default"].createElement("td", null, "125000"), _react["default"].createElement("td", null, "12/6/20107"), _react["default"].createElement("td", {
        align: "center"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/push-notifications/push-details",
        className: "button-info"
      }, "Details"))))))));
    }
  }]);

  return PushNotifications2;
}(_react["default"].Component);

exports["default"] = PushNotifications2;